import { BadStatusError } from './BadStatusError.ts';

const RATE_LIMIT_TEXT_MARK = 'rate limit exceeded';
export class RateLimitedError extends BadStatusError {
	constructor(message: string, response: Response) {
		super(`${message} ${RATE_LIMIT_TEXT_MARK}`, response);
	}
}
